import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Snackbar,
} from '@mui/material';
import './SubscribePopup.css';

function SubscribePopup({ open, onClose }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !name) {
      setError('Bitte fülle alle Felder aus');
      setShowSnackbar(true);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await addDoc(collection(db, 'emails'), {
        email,
        name,
      });
      
      setShowSnackbar(true);
      onClose();
      setEmail('');
      setName('');
    } catch (err) {
      setError('Ein Fehler ist aufgetreten');
      setShowSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Updates erhalten</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit}>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              type="text"
              fullWidth
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Email"
              type="email"
              fullWidth
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Abbrechen</Button>
          <Button 
            onClick={handleSubmit} 
            variant="contained"
            disabled={loading}
          >
            Abonnieren
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        message={error || "Erfolgreich abonniert!"}
        sx={{ 
          '& .MuiSnackbarContent-root': {
            backgroundColor: error ? '#d32f2f' : '#43a047'
          }
        }}
      />
    </>
  );
}

export default SubscribePopup; 